import React from "react";
import { VegaChip } from "@heartlandone/vega-react";

function ActivityCharge({ chargeAmount }) {
  return (
    <VegaChip
      text={chargeAmount <= 0 ? `Free` : `$ ${chargeAmount}`}
      size="small"
      variant="outlined"
    ></VegaChip>
  );
}

export default ActivityCharge;
